import { ALERT_CLEAR, ALERT_ERROR, ALERT_SUCCESS, CLOSE_SNACKBAR, ENQUEUE_SNACKBAR, REMOVE_SNACKBAR } from '../actions/AlertsActions'

const defaultState = {
	notifications: []
}

export default function alert(state = defaultState, action) {
	switch (action.type) {
		case ALERT_SUCCESS:
			return {
				type: 'success',
				message: action.message
			}
		case ALERT_ERROR:
			return {
				type: 'danger',
				message: action.message
			}
		case ALERT_CLEAR:
			return {}
		case ENQUEUE_SNACKBAR:
			const def = state.notifications ? state.notifications : []
			return {
				...state,
				notifications: [
					...def,
					{
						key: action.key,
						...action.notification
					}
				]
			}

		case CLOSE_SNACKBAR:
			return {
				...state,
				notifications: state.notifications.map((notification) =>
					action.dismissAll || notification.key === action.key ? { ...notification, dismissed: true } : { ...notification }
				)
			}

		case REMOVE_SNACKBAR:
			const result =
				state && state.notifications && state.notifications.filter ? state.notifications.filter((notification) => notification.key !== action.key) : []
			return {
				...state,
				notifications: result
			}
		default:
			return state
	}
}
